import { createContext } from "react";

// QuestionInteractiveWrapper provides a DOM node here so that
// QuestionInteractive can portal its navigation buttons out of the right
// column of InteractiveLayout into a full-width footer below.
//
// When the context value is null (e.g. QuestionInteractive rendered outside
// the wrapper — search readOnly, isolated previews) the navigation falls
// back to inline rendering.
export const InteractiveNavFooterContext = createContext(null);
